import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import JobListLayout from '../components/Jobs/JobList/JobListLayout';
import JobList from '../components/Jobs/JobList';
import withQuery from '../lib/withQuery';
import positionsQuery from '../lib/queries/jobs/positionsQuery.graphql';
import withApollo from '../lib/apollo';
import { useSiteContext } from '../components/SiteContext';
import messages from '../lib/messages.json';
import LoadMore from '../components/LoadMore';
import loadMore from '../lib/queries/loadMore';

const JobsPositionsList = ({
  data, loading, fetchMore, variables,
}) => {
  const { positionsConnection: { edges, pageInfo: { hasNextPage } } } = data;
  const intl = useIntl();

  return (
    <>
      <JobList
        listData={edges.map(
          ({
            node: {
              name,
              names,
              slug,
              jobsCount,
            },
          }) => ({
            name,
            names,
            slug,
            jobsCount,
          }),
        )}
        labelKey="jobs-positions.jobs"
        nameKey="position"
        labelHeading={intl.formatMessage(messages.jobPosition)}
        paramKey="positionSlug"
      />
      <LoadMore
        loading={loading}
        hasNextPage={hasNextPage}
        fetchMore={
          () => loadMore({
            variables,
          })(data, 'positionsConnection', fetchMore)
        }
      />
    </>
  );
};

JobsPositionsList.propTypes = {
  variables: PropTypes.shape({}).isRequired,
  fetchMore: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    positionsConnection: PropTypes.shape({
      edges: PropTypes.arrayOf(
        PropTypes.shape({}),
      ),
      pageInfo: PropTypes.shape({
        hasNextPage: PropTypes.bool,
      }),
    }),
  }),
};

JobsPositionsList.defaultProps = {
  data: {},
};

const JobsPositionsListWithQuery = withQuery(JobsPositionsList);

const JobPositions = () => {
  const intl = useIntl();
  const { jobsLocale } = useSiteContext();

  return (
    <JobListLayout
      breadcrumbLabel={intl.formatMessage(messages.positions)}
      listPrefix="jobs-positions"
    >
      <JobsPositionsListWithQuery
        query={positionsQuery}
        variables={{ locales: [jobsLocale], first: 10 }}
        errorMessage="Could not load jobs by position"
      />
    </JobListLayout>
  );
};

export default withApollo(JobPositions);
